/**
 * ورود نرم عناصر با اسکرول — مشترک بین همه‌ی قالب‌ها.
 * روی عناصر دارای [data-reveal] داخل ریشه‌ی داده‌شده اجرا می‌شود.
 */
export function useReveal(root: Ref<HTMLElement | null>) {
  let cleanup: (() => void) | undefined
  let mounted = true

  onMounted(async () => {
    const rootElement = root.value
    if (!rootElement) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const [{ default: gsap }, { ScrollTrigger }] = await Promise.all([
      import('gsap'),
      import('gsap/ScrollTrigger')
    ])

    if (!mounted || root.value !== rootElement) return

    gsap.registerPlugin(ScrollTrigger)

    const context = gsap.context(() => {
      const items = rootElement.querySelectorAll<HTMLElement>('[data-reveal]')
      items.forEach((el) => {
        gsap.from(el, {
          opacity: 0, y: 26, duration: 0.7, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true }
        })
      })

      // هر سکشن هنگام ورود به دید، فرزندانش پله‌ای fade-up می‌شوند
      rootElement.querySelectorAll<HTMLElement>('section').forEach((el) => {
        const children = Array.from(el.children).filter(child =>
          !child.hasAttribute('data-decor') && !child.hasAttribute('data-reveal')
        )

        if (!children.length) return

        gsap.from(children, {
          opacity: 0, y: 30, duration: 0.8, delay: 0.35, stagger: 0.11, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 82%', once: true }
        })
      })

      const bars = rootElement.querySelectorAll<HTMLElement>('[data-bar]')
      bars.forEach((el) => {
        gsap.fromTo(el, { width: '0%' }, {
          width: el.dataset.bar + '%', duration: 1.1, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 92%', once: true }
        })
      })
    }, rootElement)

    cleanup = () => context.revert()
    ScrollTrigger.refresh()
  })

  onBeforeUnmount(() => {
    mounted = false
    cleanup?.()
  })
}
